import { Routes, Route, Navigate } from 'react-router-dom'
import { useAuth } from './context/AuthContext'
import { useState, useEffect } from 'react'
import Sidebar from './components/layout/Sidebar'
import Topbar from './components/layout/Topbar'
import MobileNav from './components/layout/MobileNav'
import Dashboard from './components/pages/Dashboard'
import Projects from './components/pages/Projects'
import Reports from './components/pages/Reports'
import RAB from './components/pages/RAB'
import Materials from './components/pages/Materials'
import Workers from './components/pages/Workers'
import Invoices from './components/pages/Invoices'
import Documents from './components/pages/Documents'
import Login from './components/pages/Login'

function MainLayout() {
  const [sbOpen, setSbOpen] = useState(false)
  return (
    <div className="app">
      <Sidebar sbOpen={sbOpen} setSbOpen={setSbOpen} />
      <main className="main">
        <Topbar setSbOpen={setSbOpen} />
        <div className="content">
          <Routes>
            <Route path="/" element={<Dashboard />} />
            <Route path="/dashboard" element={<Navigate to="/" replace />} />
            <Route path="/projects" element={<Projects />} />
            <Route path="/reports" element={<Reports />} />
            <Route path="/rab" element={<RAB />} />
            <Route path="/materials" element={<Materials />} />
            <Route path="/workers" element={<Workers />} />
            <Route path="/invoices" element={<Invoices />} />
            <Route path="/documents" element={<Documents />} />
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </div>
      </main>
      <MobileNav />
    </div>
  )
}

// Loading spinner global
function Spinner() {
  return (
    <div style={{
      display: 'flex', alignItems: 'center', justifyContent: 'center',
      minHeight: '100vh', flexDirection: 'column', gap: 16,
      background: 'var(--bg-primary)'
    }}>
      <img src="/logo.png" alt="Undagi" style={{ width: 52, height: 52, objectFit: 'contain' }} />
      <div style={{ fontSize: 12, color: 'var(--text-muted)' }}>Memuat...</div>
    </div>
  )
}

function App() {
  const { user, loading } = useAuth()

  // ─── Cloudflare Fix: jangan tampilkan loading terlalu lama ───────────────
  // Jika loading lebih dari 3 detik tapi ada token di localStorage, paksa lanjut
  const [forceReady, setForceReady] = useState(false)
  useEffect(() => {
    const token = localStorage.getItem('undagi-auth-token')
    if (!token) return
    const t = setTimeout(() => {
      if (loading) setForceReady(true)
    }, 2500)
    return () => clearTimeout(t)
  }, [loading])

  const isReady = !loading || forceReady

  if (!isReady) return <Spinner />

  if (!user) {
    return (
      <Routes>
        <Route path="/login" element={<Login />} />
        <Route path="*" element={<Navigate to="/login" replace />} />
      </Routes>
    )
  }

  return (
    <Routes>
      <Route path="/*" element={<MainLayout />} />
    </Routes>
  )
}

export default App